<template>
  <div class="content">
    <div class="loader">
      <font-awesome-icon :icon="icon" :spin="icon === 'spinner'" />
      <p class="message">{{ message }}</p>
    </div>
  </div>
</template>

<script>

export default {
  components: {},

  computed: {},

  watch: {},

  mounted() {
  },

  data() {
    return {
      loading: false,
      icon: "spinner",
      message: "Cargando la información, espere un momento.",
    };
  },

  methods: {
  },
};
</script>

<style scoped>
.loader {
  display: flex;
  flex-direction: column; /* Apilar elementos verticalmente */
  justify-content: center;
  align-items: center;
  /* position: fixed; */
  /* top: 0;
  left: 0; */
  /* z-index: 9999; */
  /* width: 100vw;
  height: 100vh; */
  background-color: rgba(255, 255, 255, 0.8); /* Fondo ligero */
  color: #464646;
  font-size: 5em; /* Ajuste de tamaño */
  gap: 20px; /* Espaciado entre elementos */
}

.message {
  font-size: 0.6em; /* Ajusta el tamaño de la leyenda */
  text-align: center;
  max-width: 80%;
}
</style>
